// extracted by mini-css-extract-plugin
module.exports = {"primary":"#409eff","background":"#24292e","text":"#fff","menu":"TheSidebar_menu_EnAzD"};